import React, {useState, useContext, useEffect} from 'react';
import { IonText, IonGrid, IonRow, IonCol, IonButton, IonModal, IonHeader, IonFooter, IonContent, IonItem, IonIcon, IonCard } from '@ionic/react';
import ReactDOM from 'react-dom';
import { trashOutline } from "ionicons/icons";


import { ShowProductPicsModal } from './Modal_ShowProductPics';
import { Auth_MerchantID_context } from '../../../../storeState/auth_merchantID_context';

import { ViewInvoiceModal } from '../../../zInternal_Features/merchant/components/Modal_ViewInvoice';
import { MenuModal } from './Modal_Menu';
import {DateRange} from '../../../zInternal_Features/merchant/components/DateRange'

import '../../../../css/qavaApp.css';


export function Tab_Kitchen (props) {


    let authenticatedMerchent_context = useContext(Auth_MerchantID_context);


    const [acctID, setAcctID ] = useState(authenticatedMerchent_context.acctID);
    const [schema, setSchemaName] = useState(authenticatedMerchent_context.schema);
    let [sessionID, setSessionID ] = useState(authenticatedMerchent_context.sessionID);
    let [baseURL, setBaseURL ] = useState(authenticatedMerchent_context.baseURL);


    let [startDate, setStartDate] = useState(new Date(new Date().setDate(new Date().getDate() - 3)));
    let [endDate, setEndDate] = useState(new Date(new Date().setDate(new Date().getDate() + 1)));

    let [productPicsModal, setProductPicsModal] = useState(false);
    let [checkInModal, setCheckInModal] = useState(false);
    
    let [checkInModal_tracker, setCheckInModal_tracker] = useState(null);
    
    let [viewInventoryAvailableProducts, setViewInventoryAvailableProducts] = useState([]);
    
    let [orderID, setOrderID] = useState(null);
    let [orderTotal, setOrderTotal] = useState(null);
    let [invoiceForm, setInvoiceForm] = useState(null);
    let [showInvoiceModal, setViewInvoiceModal] = useState(null);
    let [invoiceID, setInvoiceID] = useState(null);
    let [customerInvoiceID, setCustomerInvoiceID] = useState(null);
    let [productPic3, setProductPic3] = useState(null);
    let [productPic4, setProductPic4] = useState(null);
    
    let [status, setStatus] = useState('');
    let [showMenuModal, setViewMenuModal] = useState(false);
    
        const parseArray = (raw) => {
    try {
        let v = raw;
        if (typeof v === "string") v = JSON.parse(v);
        while (typeof v === "string" && (/^\s*[\[{]/.test(v))) v = JSON.parse(v);
        return Array.isArray(v) ? v : [];
    } catch {
        console.warn("Bad itemID_list JSON:", raw);
        return [];
    }
    };


    function reloadDates(event)
    {
            
        setViewInventoryAvailableProducts([]);
        
        const requestOptions = {
                method: 'POST',
                headers: {
                    'Accept': 'text/html, application/json',
                    'content-type': 'application/json',
                },
                body: JSON.stringify({
                    Tracker: '74101_view_active_Orders_restaurantKitchen',
                    user: acctID,
                    xStartDateRange: event[0],
                    xEndDateRange: event[1],
                    sessionID: sessionID,
                }),
            };
    
            fetch(baseURL + 'hotel_merchantAcct_argsjqApp', requestOptions)
                .then(res => res.text())
                .then(res => {
                    let rows = res.toString().split('~~~');
    
                    for (let rownum = 0; rownum < rows.length - 1; ++rownum) {
                        let cols = rows[rownum].split('|');
    

                        setViewInventoryAvailableProducts((prevAvailableProducts) => {
                            return prevAvailableProducts.concat({
                                order_id: cols[0],
                                cart_id: cols[1],
                                order_phone_number: cols[2],
                                client_first_name: cols[3],
                                client_last_name: cols[4],
                                client_phone_number: cols[5],
                                client_email_address: cols[6],
                                client_payment_type: cols[7],
                                client_member_number: cols[8],
                                client_mm_provider: cols[9],
                                client_mm_number: cols[10],
                                order_total: parseFloat(cols[11]).toFixed(2),
                                order_amt_paid: parseFloat(cols[12]).toFixed(2),
                                order_start_date_reserved: cols[13],
                                order_end_date_reserved: cols[14],
                                order_start_date: cols[15],
                                order_end_date: cols[16],
                                merchant_invoice_id: cols[17],
                                invoiceForm: cols[18],
                                customer_invoice_id: cols[19],
                                invoiceTotal: parseFloat(cols[20]).toFixed(2),
                                transactionID: cols[21],
                                totalInvoiceAmount: cols[22],
                                transactionStatus: cols[23],
                                momo_provider: cols[24],
                                momo_financial_transaction_id: cols[25],
                                momo_external_id: cols[26],
                                momo_amount: cols[27],
                                momo_party_id: cols[28],
                                momo_payer_message: cols[29],
                                momo_payee_note: cols[30],
                                momo_pay_status: cols[31],
                                payment_type: cols[32],
                                verify_id_type: cols[33],
                                verify_id_number: cols[34],
                                ship_to_address: cols[35],
                                latitude: cols[36],
                                longitude: cols[37],
                                status: cols[38],
                                menu_items: parseArray(cols[39]),


                            });
                        });
                    }
                });

    }


      function deleteMenuItem(event)
    {
        let Tracker;

        if(event[0] < 100)
        {
            Tracker = "7999_delete_menuItem";
        }
        else
        {
           Tracker = "7999_delete_menuItem_order";
        }

        const requestOptions = {
            method: 'POST',
            //credentials: 'include',
            headers: {
                'Accept': 'text/html, application/json',
                'content-type': 'application/json',
                //'cookie': 'cookie',
            },
            body: JSON.stringify({
                Tracker: Tracker,
                user: acctID,
                fmc_schema: schema,
                xCheckInRoomID: event[0],
                xCustomerInvoiceID: event[1],
                xInvoiceID: event[2],
                xProductID: event[3],
                xDelete_quantity: event[4],
                xDelete_lineNumberMenu: event[5],
                sessionID: sessionID,

            }),
        }

        fetch(baseURL+'hotel_merchantAcct_argsjqApp', requestOptions)
        .then(res => res.text())
        .then(data => {

            alert(data);
            //props.closeModal_updateComplete();
            reloadDates([startDate.toISOString().substr(0, 10), endDate.toISOString().substr(0, 10)]);

        })
        .catch(error => {
            console.error(error);
        })
    }
    
    function closeModalHandler(event) {
        setViewInventoryAvailableProducts([]);
        props.closeModal(event);
    }
    
    function viewMenuModalHandler(event) {


        setOrderID(event[1]);
        setOrderTotal(event[2]);
        setInvoiceID(event[3]);
        setCustomerInvoiceID(event[4]);
        setInvoiceForm(event[5]);
        setViewMenuModal(event[0]);

    }

    function viewInvoiceModalHandler(event) {

        //alert(event);
        if(event[1] < 100)
        {
            setStatus("room");
        }
        else
        {
           setStatus("order");
        }

        setOrderID(event[1]);
        setOrderTotal(event[2]);
        setInvoiceForm(event[3]);
        setViewInvoiceModal(event[0]);

    }

    useEffect(() => {
        
        reloadDates([startDate.toISOString().substr(0, 10), endDate.toISOString().substr(0, 10)]);

    }, []);
    
    return (
        <React.Fragment>

            <IonItem>
                <IonGrid>
                        <DateRange setDate={(e) => reloadDates(e)} data={{
                        startDate: startDate, 
                        endDate: endDate
                        }}></DateRange>
                </IonGrid>
            </IonItem>
            {viewInventoryAvailableProducts.length === 0 ? (
                <div className="dot-loader">
                <span className="dot"></span>
                <span className="dot"></span>
                <span className="dot"></span>
                <span className="dot"></span>
                </div>
            ) : (
            <IonContent className='appContent_restaurant_kitchen'>           

                            {viewInventoryAvailableProducts.map((detailData) => {
                                return (
                                <IonGrid>
                                    <IonRow key={detailData.order_id} className = "outlinedHeader">
                                        {/*<IonCol size='2'>{detailData.order_id}</IonCol>*/}
                                        <IonCol size='3'>{detailData.client_first_name+" "+detailData.client_last_name}</IonCol>
                                        <IonCol size='3'>{detailData.invoiceTotal}</IonCol>
                                        <IonCol size='3' >
                                            <IonButton  onClick={() => viewMenuModalHandler([true, detailData.menu_items[0].line_number, detailData.invoiceTotal, detailData.merchant_invoice_id, detailData.customer_invoice_id, detailData.invoiceForm])}> Add </IonButton>
                                        </IonCol>
                                        <IonCol size='3'>
                                            <IonButton size="smaller" onClick={() => viewInvoiceModalHandler([true, detailData.order_id, detailData.invoiceTotal, detailData.invoiceForm])}> View </IonButton>
                                        </IonCol>
                                    </IonRow>
                                    <IonRow className="outlinedRow_smaller">
                                        <IonCol size='2'>Qty</IonCol>
                                        <IonCol size='4'>Desc</IonCol>
                                        <IonCol size='2'>Unit</IonCol>
                                        <IonCol size='2'>Total</IonCol>
                                        <IonCol size='2'>Del</IonCol>
                                    </IonRow>
                                    {detailData.menu_items.map((it) => {
                                        return (
                                            <IonRow className="outlinedRow_smaller">
                                                <IonCol size='2'>
                                                    {it.qty}
                                                </IonCol>
                                                <IonCol size='4'>
                                                    {it.description}                              
                                                </IonCol>
                                                <IonCol size='2'>
                                                    {it.unit_price}                              
                                                </IonCol>
                                                <IonCol size='2'>
                                                    {it.extended_price}                              
                                                </IonCol>
                                                <IonCol size='2'>
                                                        <IonButton fill="clear" size="small" onClick={() => deleteMenuItem([it.line_number, detailData.customer_invoice_id, detailData.merchant_invoice_id, it.product_id, it.qty, it.line_number_menu])}>
                                                                <IonIcon icon={trashOutline} />
                                                        </IonButton>
                                                </IonCol>
                                            </IonRow>
                                        )}
                                    )}
                                 </IonGrid>
                                        
                                );
                            })}

                    {showInvoiceModal == true && <ViewInvoiceModal openModal={ showInvoiceModal } closeModal={() => setViewInvoiceModal(false)} data={{
                                        fileLocation: `api/form/${invoiceForm}/${schema}`, 
                                        roomID: orderID, 
                                        roomSalePrice: orderTotal,
                                        }}></ViewInvoiceModal>}
                    
                    {showMenuModal == true && <MenuModal openModal={ showMenuModal } closeModal={() => setViewMenuModal(false)} closeModal_update={() => props.closeModal_updateComplete()} data={{
                                                    status: status,
                                                    fileLocation: invoiceForm, 
                                                    roomID: orderID, 
                                                    roomSalePrice: orderTotal,
                                                    invoiceID: invoiceID,
                                                    customerInvoiceID: customerInvoiceID,
                                                    }}></MenuModal>}
            </IonContent>
            )}
        </React.Fragment>

    )
}